import clsx from "clsx";
import { CircleDollarSignIcon, ClockIcon, MapPinIcon } from "lucide-react";

import { RichTextDisplay } from "@/components";
import { Badge } from "@/components/ui/badge";

import { employmentTypeToLabel } from "@/lib/constants";
import { CompensationType, Job } from "@/types";

export const JobOverview = ({
  className,
  job,
}: {
  className?: string;
  job: Job;
}) => {
  return (
    <div className={clsx("flex flex-col gap-6", className)}>
      <div className="flex items-center gap-2">
        <Badge className="flex items-center gap-1">
          <ClockIcon className="h-4 w-4" />
          {employmentTypeToLabel[job.employmentType]}
        </Badge>
        <Badge className="flex items-center gap-1">
          <MapPinIcon className="h-4 w-4" />
          {job.city}, {job.state}
        </Badge>
        <Badge className="flex items-center gap-1">
          <CircleDollarSignIcon className="h-4 w-4" />${job.compensationMin} - $
          {job.compensationMax}{" "}
          {job.compensationType === CompensationType.HOURLY
            ? "per hour"
            : "per year"}
        </Badge>
      </div>
      <div className="flex flex-col gap-6">
        {/* TODO: Make these reusable. */}
        <div className="flex flex-col gap-2">
          <p className="font-semibold text-slate-800">Job Summary</p>
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
            <RichTextDisplay richText={job.overview} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <p className="font-semibold text-slate-800">Responsibilities</p>
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
            <RichTextDisplay richText={job.responsibilities} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <p className="font-semibold text-slate-800">Qualifications</p>
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
            <RichTextDisplay richText={job.qualifications} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <p className="font-semibold text-slate-800">Benefits</p>
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
            {job.benefits ? (
              <RichTextDisplay richText={job.benefits} />
            ) : (
              <p className="font-medium text-slate-400">No benefits</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
